
// NOTE: if you are rendering a waveform of 160 peaks, add width="479px" directly on canvas element
// This will help render peaks properly. The containing div can control the display size of the canvas 
export async function renderWaveform(canvas, songVersionId, options = {}) {
    if (!canvas || !songVersionId) return
  
    try {
      const response = await fetch(`/api/v1/song_versions/${songVersionId}/get_waveform_data`)
      if (!response.ok) throw new Error("Failed to fetch waveform data")
      const json = await response.json()
      const data = json["waveform_data"]
  
      const ctx = canvas.getContext("2d")
      const width = canvas.width
      const height = canvas.height * 2 // for vertical only peaks, height is 2x canvas height.

      ctx.clearRect(0, 0, width, height)
      ctx.fillStyle = options.color || "#999"
  
      data.forEach((amp, i) => {
        const x = (i / data.length) * width
        const barHeight = (amp / 100) * height - 5
        ctx.fillRect(x, (height - barHeight) / 2, 2, barHeight)
      })
    } catch (err) {
      console.error("Error rendering waveform:", err)
    }
  }
  